import React from 'react';
import FormInput from '../forms/FormInput';
import Button from '../common/Button';
import Card from '../common/Card';
import { useForm } from '../../hooks/useForm';
import { validators } from '../../utils/validators';
import { theme } from '../../config/theme';

const BankDetailsForm = ({ seller, onSubmit, loading }) => {
  const { values, errors, touched, handleChange, handleBlur, validate, setValues } = useForm(
    {
      bank_name: seller?.bank_name || '',
      bank_account_number: seller?.bank_account_number || '',
      ifsc_code: seller?.ifsc_code || '',
      branch_name: seller?.branch_name || '',
    },
    {
      bank_name: (value) => validators.required(value, 'Bank name'),
      bank_account_number: (value) => validators.accountNumber(value),
      ifsc_code: (value) => validators.ifsc(value),
    }
  );

  React.useEffect(() => {
    if (seller) {
      setValues({
        bank_name: seller.bank_name || '',
        bank_account_number: seller.bank_account_number || '',
        ifsc_code: seller.ifsc_code || '',
        branch_name: seller.branch_name || '',
      });
    }
  }, [seller, setValues]);

  const handleIFSCBlur = async (e) => {
    handleBlur(e);
    const ifsc = values.ifsc_code;
    if (ifsc && ifsc.length === 11) {
      try {
        const response = await fetch(`https://ifsc.razorpay.com/${ifsc}`);
        const data = await response.json();
        setValues(prev => ({
          ...prev,
          bank_name: data.BANK || prev.bank_name,
          branch_name: data.BRANCH || prev.branch_name,
        }));
      } catch (error) {
        // Ignore IFSC lookup errors
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;
    await onSubmit(values);
  };

  return (
    <Card padding="xl">
      <h2 style={{
        fontSize: theme.typography.fontSize.xl,
        fontWeight: theme.typography.fontWeight.semibold,
        marginBottom: theme.spacing.xl,
      }}>
        Bank Details
      </h2>

      <form onSubmit={handleSubmit}>
        <FormInput
          label="IFSC Code"
          name="ifsc_code"
          value={values.ifsc_code}
          onChange={handleChange}
          onBlur={handleIFSCBlur}
          error={errors.ifsc_code}
          touched={touched.ifsc_code}
          placeholder="SBIN0001234"
          required
        />

        <FormInput
          label="Bank Name"
          name="bank_name"
          value={values.bank_name}
          onChange={handleChange}
          onBlur={handleBlur}
          error={errors.bank_name}
          touched={touched.bank_name}
          required
        />

        <FormInput
          label="Account Number"
          name="bank_account_number"
          value={values.bank_account_number}
          onChange={handleChange}
          onBlur={handleBlur}
          error={errors.bank_account_number}
          touched={touched.bank_account_number}
          required
        />

        <FormInput
          label="Branch Name"
          name="branch_name"
          value={values.branch_name}
          onChange={handleChange}
          onBlur={handleBlur}
        />

        <Button type="submit" loading={loading} disabled={loading}>
          Update Bank Details
        </Button>
      </form>
    </Card>
  );
};

export default BankDetailsForm;